import ImageOverShape from "../../../components/ImageOverShape/ImageOverShape";
import { useAppContext } from "../../../context/AppState/AppContext";
import "./CoursesHero.css";


const CoursesHero = () => {

   const { jsonTexts, jsonMedia } = useAppContext()
   const { heroTitle, heroDescription } = jsonTexts?.coursesPage

   const HERO_DATA = [
      {
         title: heroTitle,
         description: heroDescription,
         imageUrl: jsonMedia?.courses?.heroImage,
      },
   ];

   return (
      <div className="coursesLandingHero-father-div-container">
         {HERO_DATA.map((heroInfo, index) => (
            <div key={index} className="coursesLandingHero-content-wrapper">
               <div className="coursesLandingHero-image-container">
                  <ImageOverShape
                     straightSide="left"
                     height={150}
                     imageUrl={heroInfo.imageUrl}
                  />
               </div>
               <div className="coursesLandingHero-all-content-container-div">
                  <div className="coursesLandingHero-title-and-description-div">
                     <div className="coursesLandingHero-title-and-description-content-div">
                        <h2 className="coursesLandingHero-title-h1-styling">
                           {heroInfo.title}
                        </h2>
                        <p className="coursesLandingHero-paragraph-p-styling">
                           {heroInfo.description}
                        </p>
                     </div>
                  </div>
               </div>
            </div>
         ))}
      </div>
   );
};

export default CoursesHero;
